function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Technical support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M168.184,51.306a97.8,97.8,0,0,1,60.055-28.764,99.045,99.045,0,0,0-9.946-.5A98.833,98.833,0,0,0,127.27,82.591a171.958,171.958,0,0,0,20.017-.039A98.487,98.487,0,0,1,168.184,51.306Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.934,143.429l-.159-14.294c-1.375.027-2.717.042-4.008.042-6.6,0-12.052-.318-16-.656l.165,14.908a273.58,273.58,0,0,0,43.627,1.906C155.476,145.013,147.539,144.336,139.934,143.429Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.941,116.9c-2.4-.126-4.479-.283-6.166-.436A98.7,98.7,0,0,1,143.1,94.781c-2.229.075-4.346.11-6.32.11-5.8,0-10.419-.276-13.567-.545a98.649,98.649,0,0,0-3.439,22.114A188.9,188.9,0,0,0,145.941,116.9Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.871,157.563c25.634,0,47.891-3.9,66.463-11.577a61.651,61.651,0,0,1-3.584-8.344c-19.238,11.915-43.844,18.533-73.23,19.712Q168.78,157.558,173.871,157.563Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,191.121v-.142a6,6,0,0,0-4.959-5.91,17.771,17.771,0,0,1-14.149-21.715A11.476,11.476,0,0,1,128.7,156.4q-7.332-.649-14.965-1.661a6.025,6.025,0,0,1-.816-.173,11.819,11.819,0,0,0-9.024,8.786,17.771,17.771,0,0,0,14.149,21.715,6,6,0,0,1,4.959,5.91v.142c0,48.124,39.158,87.445,87.283,87.445A95.862,95.862,0,0,0,220.4,278,87.584,87.584,0,0,1,143,191.121Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,311.849V289.126a97.052,97.052,0,0,1-20-5.386v28.109a87.35,87.35,0,0,0,45.653,6.994A83.98,83.98,0,0,1,195,311.849Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.273,290.232l14.93-46.6A99.923,99.923,0,0,1,114.7,217.12L91.273,290.232a264.9,264.9,0,0,0,43.469,3.8l.2-.85C124.605,292.374,116.446,291.154,111.273,290.232Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.715,277.4l-3.84,16.069c2.518-.162,5.163-.362,8.125-.605V278.14c-1.273-.682-2.522-1.394-3.757-2.126A5.981,5.981,0,0,0,158.715,277.4Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.641,328.375l4.957-2.116a99.762,99.762,0,0,1-10.393-4.1l-14.564,6.216a97.828,97.828,0,0,0,66.9,17.671A97.353,97.353,0,0,1,173.641,328.375Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,345.743l15.358-6.542c-2.494-1.707-4.927-3.508-7.263-5.426L112.9,345.743C99.493,352.515,90,365.962,89,380.92V453h20V380.92C110,365.962,119.493,352.515,132.9,345.743Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.578,410.3a79.767,79.767,0,0,1,69.666-79.016,79.666,79.666,0,1,0,0,158.032A79.767,79.767,0,0,1,283.578,410.3Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,205.537a6,6,0,0,0,6-6V184.545a6,6,0,1,0-12,0v14.992A6,6,0,0,0,162,205.537Z",
    style: {
      fill: "#09588d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,205.537a6,6,0,0,0,6-6V184.545a6,6,0,1,0-12,0v14.992A6,6,0,0,0,258,205.537Z",
    style: {
      fill: "#09588d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.729,167H349v-1.379c0-11.746-9-21.53-20-23.506V120.646a110.65,110.65,0,1,0-221.294,1.222l.232,21.62a23.659,23.659,0,0,0-15.7,17.012,29.792,29.792,0,0,0,16.734,34.255L77.805,292.979a6,6,0,0,0,4.286,7.641c1.166.287,22.866,5.452,54.733,5.451,8.037,0,16.176-.337,26.176-1.155v6.611l-54.709,23.252c-.111.048-.334.1-.442.153a56.185,56.185,0,0,0-30.726,45.232c-.014.165-.123.332-.123.5v78A6.376,6.376,0,0,0,83.09,465H273V453H240V354.631a106.244,106.244,0,0,0,40.051-20.859l18.157,7.749,4.959-11.038L259,311.527V304.7c12,1.069,27.791,1.3,28.52,1.3h0a6.1,6.1,0,0,0,4.944-2.7l4.617-6.767,2.054,5.171a5.968,5.968,0,0,0,5.965,3.769c21.688-1.392,35.305-4.7,35.874-4.842a6.162,6.162,0,0,0,4.387-7.646L322,219.031V205h2.738C337.9,205,349,194.623,349,181.457V179h5.729a6,6,0,1,0,0-12ZM317,120.646V142H303.881A5.687,5.687,0,0,0,298,147.744v23.708a87.561,87.561,0,0,1-19.852-6.343c-16.488-7.628-26.94-19.317-31.072-34.769A94.879,94.879,0,0,0,267.391,107.7a6,6,0,0,0-10.108-6.486c-28.677,44.642-89.554,47.916-137.349,42.219l-.165-14.908c3.946.338,9.393.656,16,.656a210.162,210.162,0,0,0,34.469-2.849c42.512-7.109,77.819-27.22,102.1-58.157a6,6,0,1,0-9.439-7.41c-22.649,28.853-54.361,46.909-94.258,53.667a195.524,195.524,0,0,1-48.868,2.032,98.649,98.649,0,0,1,3.439-22.114c3.148.269,7.772.545,13.567.545a193.9,193.9,0,0,0,36.367-3.482c48.171-9.267,78.424-34.411,95.9-55.3A98.692,98.692,0,0,1,317,120.646Zm-7,86.9v28.223c0,8.579-7.18,15.226-15.759,15.226h-4.678A86.551,86.551,0,0,0,310,207.551ZM148.184,51.306a98.57,98.57,0,0,1,109.9-20.873c-22.168,25.69-51.329,42.2-86.787,49.112a179.488,179.488,0,0,1-44.028,3.046A98.475,98.475,0,0,1,148.184,51.306Zm-44.8,116.287a17.842,17.842,0,0,1,.508-4.239,11.819,11.819,0,0,1,9.024-8.786,6.025,6.025,0,0,0,.816.173,304.869,304.869,0,0,0,40.139,2.822c33.691,0,61.567-6.722,82.879-19.921,5.767,16.8,18.219,29.966,36.359,38.359A96.669,96.669,0,0,0,298,183.649v15.686a5.154,5.154,0,0,0,.416,2.177c-1.286,17.779-9,33.488-24.951,49.488h-.324a17.74,17.74,0,0,0-16.828-13H216.036A17.1,17.1,0,0,0,199,255.311v4.043C199,268.9,206.493,277,216.036,277h11.576a99.884,99.884,0,0,1-17.329,1.566c-48.125,0-87.283-39.321-87.283-87.445v-.142a6,6,0,0,0-4.959-5.91A17.7,17.7,0,0,1,103.384,167.593ZM247,311.849c-23,10.068-50,10.068-72,0V283.74a98.507,98.507,0,0,0,35.766,6.657A101.532,101.532,0,0,0,247,283.569Zm15-52.157A5.307,5.307,0,0,1,256.693,265H216.307A5.307,5.307,0,0,1,211,259.692v-4.384A5.307,5.307,0,0,1,216.307,250h40.386A5.307,5.307,0,0,1,262,255.308ZM147.333,293.857l3.142-13.673a6.042,6.042,0,0,0-11.76-2.78l-3.973,16.628a264.889,264.889,0,0,1-43.469-3.8L114.7,217.12A97.771,97.771,0,0,0,163,278.14v14.728C157,293.36,152.294,293.678,147.333,293.857ZM89,380.92c1-14.958,10.493-28.405,23.9-35.177L141,333.775a113.063,113.063,0,0,0,34,18.943V453H89ZM228,389H215.06a6,6,0,1,0,0,12H228v18H215.06a6,6,0,1,0,0,12H228v22H187V356.088c8,1.673,15.332,2.912,23.22,2.912h.3A112.843,112.843,0,0,0,228,357.246Zm39.417-60.621a98.041,98.041,0,0,1-113.776,0l14.564-6.216a101.51,101.51,0,0,0,84.638,0Zm41.263-35.212L304.1,281.589A6,6,0,0,0,293.58,280.4l-8.947,13.375c-5.378-.065-16.633-.3-25.633-1.115V277.91c1-.687,2.209-1.39,3.415-2.131.172-.106.213-.385.37-.5A16.609,16.609,0,0,0,273.141,263h21.1A27.433,27.433,0,0,0,318.6,248.469l13.2,41.688C326.711,291.07,318.746,292.359,308.68,293.167ZM337,181.457c0,6.55-5.713,11.543-12.262,11.543H310V154h14.738c6.549,0,12.262,5.072,12.262,11.621Z",
    style: {
      fill: "#09588d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,205.537a6,6,0,0,0,6-6V184.545a6,6,0,1,0-12,0v14.992A6,6,0,0,0,162,205.537Z",
    style: {
      fill: "#09588d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,205.537a6,6,0,0,0,6-6V184.545a6,6,0,1,0-12,0v14.992A6,6,0,0,0,258,205.537Z",
    style: {
      fill: "#09588d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.244,318.63A91.666,91.666,0,1,0,434.91,410.3,91.77,91.77,0,0,0,343.244,318.63Zm0,171.332A79.666,79.666,0,1,1,422.91,410.3,79.756,79.756,0,0,1,343.244,489.962Z",
    style: {
      fill: "#f86f4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.244,375.841a14.016,14.016,0,0,1,14,14,6,6,0,0,0,6,6,5.9,5.9,0,0,0,5.878-6A25.578,25.578,0,0,0,349,364.547v-5.7a6,6,0,0,0-12,0v5.7a26.428,26.428,0,0,0-19.878,25.294,26.081,26.081,0,0,0,26.061,26,14,14,0,0,1,.19,27.992c-.048,0-.088-.007-.137-.007s-.092.006-.141.007a14.008,14.008,0,0,1-13.853-13.992,6,6,0,0,0-6-6,6.1,6.1,0,0,0-6.122,6A26.429,26.429,0,0,0,337,455.134v6.6a6,6,0,1,0,12,0v-6.6a25.577,25.577,0,0,0,20.122-25.293,25.977,25.977,0,0,0-25.939-26,14,14,0,1,1,.061-28Z",
    style: {
      fill: "#f86f4b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.acaa2ba196cd56d1b5f3d84418094354.svg";
export { ForwardRef as ReactComponent };